import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70fd9aeb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toolbar__buttons" }

import {
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButton,
} from '@ionic/vue';

interface Props {
  code: string | number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PackageDetailsHeader',
  props: {
    code: null
  },
  setup(__props: any) {

const props = __props as {
  code: string | number;
};



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_unref(IonHeader), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonToolbar), { class: "product__wrapper" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonTitle), null, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          })
        ]),
        _: 3
      }),
      _createVNode(_unref(IonToolbar), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_router_link, {
              class: "toolbar__link",
              to: { name: 'scan/article-result', params: { code: props.code } }
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButton), { class: "toolbar__button" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Main article ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 3
  }))
}
}

})